import { Divider } from "@ps-design-system/components/Divider";
import { Skeleton } from "@ps-design-system/components/Skeleton";

const SkeletonSection = () => {
  return (
    <div className="tw-flex tw-flex-col tw-gap-16">
      <div className="tw-flex tw-flex-col tw-gap-8">
        <Skeleton height={36} width="100%" classNames="tw-max-w-[550px]" />
        <Skeleton height={24} width="100%" classNames="tw-max-w-[736px]" />
      </div>

      <Skeleton height={96} width="100%" classNames="tw-max-w-[450px]" />

      <Skeleton height={32} width="100%" classNames="tw-max-w-[400px]" />

      <Skeleton height={40} width="100%" />
    </div>
  );
};

const SpaceEditorLayoutSkeleton = () => {
  return (
    <div className="space-editor-page tw-py-64 tw-min-h-[calc(100dvh-72px)]">
      <SkeletonSection />

      <Divider spacing={48} />

      <SkeletonSection />

      <Divider spacing={48} />

      <div className="tw-flex tw-justify-between">
        <Skeleton height={40} width={68} />
        <Skeleton height={40} width={68} />
      </div>
    </div>
  );
};

export { SpaceEditorLayoutSkeleton };
